import { makeStyles } from "@material-ui/core";
import { useEffect, useReducer } from "react";
import CustomTabStyle from "../../componentes/tabs/CustomTabStyle";
import CustomTabs from "../../componentes/tabs/CustomTabs";
import { useTranslation } from "react-i18next";
import a11yProps from "../../componentes/tabs/a11Props";
import TabPanel from "../../componentes/tabs/TabPanel";
import FormContainer from "../../componentes/form-container/FormContainer";
import CreateIcon from "@material-ui/icons/Create";
import LabelScanningColoplast from "./LabelScanningColoplast";
import LabelScanningUfi from "./LabelScanningUfi";
import LabelScanningGeneric from "./LabelScanningGeneric";
import PrintIcon from "@material-ui/icons/Print";
import LabelScanningMotul from "./LabelScanningMotul";


const useStyles = makeStyles((theme) => ({
    root: {
        marginRight: 10,
    },
}));

const reducer = (state, data) => {
    return { ...state, ...data }
}

const LabelScanningControl = () => {

    const loggedIdClient = Number(sessionStorage.getItem("idClient") || 0);
    const initialTab = (() => {
        if (loggedIdClient === 1) return 0; // Coloplast
        if (loggedIdClient === 2) return 1; // UFI
        if (loggedIdClient === 0) return 0; // Admin começa no 0
        return 2; // Generic
    })();

    const initialState = {
        id: 0,
        tabValue: initialTab,
    };
    const { t } = useTranslation();
    const classes = useStyles();
    const [state, dispatch] = useReducer(reducer, {
        id: 0,
        tabValue: 0
    });
    const { id, tabValue } = state
    const handleTabChange = (event, newValue) => dispatch({ tabValue: newValue });


    const tabs = [];
    if (loggedIdClient === 0 || loggedIdClient === 1) {
        tabs.push({
            key: "coloplast",
            label: t("productColoplast"),
            component: <LabelScanningColoplast updateId={dispatch} />
        });
    }

    if (loggedIdClient === 0 || loggedIdClient === 2) {
        tabs.push({
            key: "ufi",
            label: t("productUfi"),
            component: <LabelScanningUfi updateId={dispatch} />
        });
    }

    if (loggedIdClient === 0 || loggedIdClient === 8) {
        tabs.push({
            key: "motul",
            label: t("productMotul"),
            component: <LabelScanningMotul updateId={dispatch} />
        });
    }

    if (loggedIdClient === 0 || (loggedIdClient !== 1 && loggedIdClient !== 2 && loggedIdClient !== 8)) {
        tabs.push({
            key: "generic",
            label: t("productGeneric"),
            component: <LabelScanningGeneric updateId={dispatch} />
        });
    }

    useEffect(() => {
        let index = 0;

        // if (loggedIdClient === 2) {
        //     index = tabs.findIndex(t => t.key === "ufi");
        // } else if (loggedIdClient !== 1 && loggedIdClient !== 2) {
        //     index = tabs.findIndex(t => t.key === "coloplast");
        // }

        if (loggedIdClient === 1) {
            index = tabs.findIndex(t => t.key === "coloplast");
        }
        else if (loggedIdClient === 2) {
            index = tabs.findIndex(t => t.key === "ufi");
        }
        else if (loggedIdClient === 8) {
            index = tabs.findIndex(t => t.key === "motul");
        }

        if (index < 0) index = 0;

        dispatch({ tabValue: index });
    }, [loggedIdClient]);

    return (
        <>
            <FormContainer>
                <CustomTabs value={tabValue} onChange={handleTabChange}>
                    {tabs.map((tab, index) => (
                        <CustomTabStyle
                            key={tab.key}
                            label={tab.label}
                            {...a11yProps(index)}
                            icon={<PrintIcon fontSize="small" />}
                        />
                    ))}
                </CustomTabs>

                {tabs.map((tab, index) => (
                    <TabPanel key={tab.key} value={tabValue} index={index}>
                        {tab.component}
                    </TabPanel>
                ))}
            </FormContainer>
        </>
    )
}

export default LabelScanningControl;